import React from 'react';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

import 'financing/components/FinancingState/FinancingState.scss';

const FinancingState = () => {
    const contentZoneFinancingMessage = ContentZonesService.getContentZone(
        'widget.checkout',
        'widget.checkout.financing.message'
    );
    const FinancingMessage = contentZoneFinancingMessage
        ? contentZoneFinancingMessage.getValue() || LocaleService.t('FINANCING.SUBTITLE')
        : LocaleService.t('FINANCING.SUBTITLE');
    return (
        <div className="confirm_financing--wrapper">
            <div className="confirm_financing--icon">
                <icon className="icon-Crochet" />
            </div>
            <div className="confirm_financing--content">
                <p className="confirm_financing--title is-bold">{LocaleService.t('FINANCING.CONGRATS')}</p>
                <p className="confirm_financing--subtitle sr-text is-bold">{LocaleService.t('FINANCING.TITLE')}</p>
                <p>{FinancingMessage}</p>
            </div>
        </div>
    );
};

FinancingState.displayName = 'FinancingState';

export default FinancingState;
